import type { Role } from '@/types';

export const ROLE_LABELS: Record<Role, string> = {
  super_admin: 'Super Admin',
  category_manager: 'Category Manager',
  team_lead: 'Team Lead',
  sales_executive: 'Sales Executive',
  doctor: 'Doctor',
  hospital: 'Hospital',
  billing_insurance: 'Billing / Insurance',
  city_team: 'City Team',
  emi_team: 'EMI Team',
};

export const NAV_ACCESS: Record<string, Role[]> = {
  dashboard: ['super_admin', 'category_manager', 'team_lead', 'sales_executive', 'doctor', 'hospital', 'billing_insurance', 'city_team', 'emi_team'],
  leads: ['super_admin', 'category_manager', 'team_lead', 'sales_executive', 'city_team'],
  calls: ['super_admin', 'category_manager', 'team_lead', 'sales_executive'],
  appointments: ['super_admin', 'category_manager', 'team_lead', 'sales_executive', 'doctor', 'hospital'],
  documents: ['super_admin', 'category_manager', 'team_lead', 'sales_executive', 'doctor', 'hospital', 'billing_insurance'],
  reports: ['super_admin', 'category_manager', 'team_lead'],
  integrations: ['super_admin', 'category_manager'],
  ads: ['super_admin', 'category_manager'],
  admin: ['super_admin', 'category_manager'],
  templates: ['super_admin', 'category_manager', 'team_lead'],
  audit: ['super_admin', 'category_manager', 'team_lead'],
  settings: ['super_admin', 'category_manager', 'team_lead', 'sales_executive', 'doctor', 'hospital', 'billing_insurance', 'city_team', 'emi_team'],
};

export function canAccess(role: Role, section: string): boolean {
  return NAV_ACCESS[section]?.includes(role) ?? false;
}

export function getDefaultRoute(role: Role): string {
  const routes: Partial<Record<Role, string>> = {
    super_admin: '/',
    category_manager: '/',
    team_lead: '/calls',
    sales_executive: '/calls',
    doctor: '/appointments',
    hospital: '/appointments',
    billing_insurance: '/leads',
    city_team: '/leads',
    emi_team: '/leads',
  };
  return routes[role] ?? '/';
}
